import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AlertService } from './alert.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { UtilsService } from './utils.service';
import { CreateOrderMedicinePayload, OrderMedicine, UpdateOrderMedicinePayload } from 'src/interfaces/order-medicine';

@Injectable({
  providedIn: 'root'
})
export class OrderMedicineService {
  baseUrl: string = environment.api.baseUrl;
  headers: HttpHeaders;
  totalItems: number = 0;

  constructor(
    private _http: HttpClient,
    private _alertService: AlertService,
    private _auth: AuthService,
    private _utilsService: UtilsService
  ) {
    this._auth.generateRequestHeaders()
      .then((headers) => {
        this.headers = headers;
      });
  }

  async getOrderMedicines(page: number = 1, limit: number = 10, search: string | null = null): Promise<OrderMedicine[]> {
    let queryString: string = `?page=${page}&limit=${limit}`;
    
    if (search) {
      queryString += `&search=${search}`;
    }

    try {
      const { data } = await this._http
        .get<any>(`${this.baseUrl}/ordermedicine${queryString}`, {
          headers: this.headers
        })
        .toPromise();
        console.log('med data', data)
      this.totalItems = data ? data.total : 0;
      return data ? data.results : [];
    } catch (error) {
      console.log('med error', error)
      this._utilsService.showError(error);
      return [];
    }
  }

  async getOrderMedicine(id: number): Promise<OrderMedicine | null> {
    try {
      const { data } = await this._http
        .get<any>(`${this.baseUrl}/ordermedicine/${id}`, {
          headers: this.headers
        })
        .toPromise();

      return data || null;
    } catch (error) {
      this._utilsService.showError(error);
      return null;
    }
  }

  async createOrderMedicine(payload: CreateOrderMedicinePayload): Promise<OrderMedicine | null> {
    try {
      const { data, message } = await this._http
        .post<any>(`${this.baseUrl}/ordermedicine`, payload, {
          headers: this.headers
        })
        .toPromise();

      this._alertService.openSnackBar(message);
      return data || null;
    } catch (error) {
      this._utilsService.showError(error);
      return null;
    }
  }

  async updateOrderMedicine(id: number, payload: UpdateOrderMedicinePayload): Promise<boolean> {
    try {
      const { success, message } = await this._http
        .put<any>(`${this.baseUrl}/ordermedicine/${id}`, payload, {
          headers: this.headers
        })
        .toPromise();

      this._alertService.openSnackBar(message);
      return success;
    } catch (error) {
      this._utilsService.showError(error);
      return false;
    }
  }

  async deleteOrderMedicine(id: number): Promise<boolean> {
    try {
      const { success, message } = await this._http
        .delete<any>(`${this.baseUrl}/ordermedicine/${id}`, {
          headers: this.headers
        })
        .toPromise();

      this._alertService.openSnackBar(message);
      return success;
    } catch (error) {
      this._utilsService.showError(error);
      return false;
    }
  }

  getTotalOrderMedicines(): number {
    return this.totalItems;
  }
} 